import {makeAutoObservable} from "mobx";
import {host} from "@/utils/hostConf";
import * as http from "@/utils/baseRequest";

class Store {
    list = [];
    docInfo = {};

    constructor(){
        makeAutoObservable(this)
    }

    // 科室查询 | 查询分院的科室
    fetchDept(data) {
        let postData = {
            query_type: 1,
            page_no: 1,
            page_size: 999,
            ...data
        };
        return http.get({
            url: host.cplus+'cgi-bin/user/queryshop2dept',
            data: postData
        })
    }

    // 查询分院的列表
    fetchShopList(data) {
        let postData = {
            query_type: 1,
            page_no: 1,
            page_size: 999,
            ...data
        };
        return http.get({
            url: host.cplus+'cgi-bin/mix/queryshop',
            data: postData
        })
    }

    // 查询城市的列表
    fetchCityList(data) {
        let postData = {
            query_type: 1,
        };
        return http.get({
            url: host.cplus+'cgi-bin/mix/querycity',
            data: postData
        })
    }

    // 查询科室的列表
    fetchDeptList(data) {
        return http.get({
            url: host.cplus+'cgi-bin/user/queryshop2dept',
            data
        })
    }
}

export default new Store();
